import React from "react";
import { Card, CardBody } from "reactstrap";
import {
    TrendingUp,
    TrendingDown
} from "react-feather";


const DashboardStatCard = ({
    title,
    subtitle,
    value,
    growth,
    growthLabel,
    // Período exacto contra el que se comparó. Va como tooltip de la etiqueta:
    // la tarjeta dice "vs mes anterior", y al pasar el mouse se ven las fechas.
    growthTitle,
    // Texto a mostrar en lugar de la variación cuando la tarjeta todavía no
    // tiene fuente de datos. Sin esto, una tarjeta sin endpoint decía
    // "Sin período anterior para comparar", que da a entender que el valor sí
    // se midió y sólo falta con qué compararlo.
    pendingNote,
    icon,
    iconBg = "#EEF8F2",
    iconColor = "#28C76F"
}) => {

    // Un crecimiento nulo no es cero: significa que no hay período anterior
    // con el cual comparar. Pintarlo como "0%" con flecha verde diría que las
    // ventas quedaron iguales, que es una afirmación distinta.
    const hasGrowth = growth !== null && growth !== undefined && growth !== '';
    const positive = growth >= 0;

    return (
        <Card className="border-0 shadow-sm h-80 dashboard-stat-card">
            <CardBody>

                <div className="d-flex justify-content-between">

                    <div>

                        <div
                            style={{
                                fontSize:13,
                                color:"#8A8D93",
                                fontWeight:500
                            }}
                        >
                            {title}
                        </div>

                        <small
                            style={{
                                color:"#B9B9C3"
                            }}
                        >
                            {subtitle}
                        </small>

                    </div>

                    <div
                        style={{
                            width:42,
                            height:42,
                            borderRadius:"50%",
                            background:iconBg,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center"
                        }}
                    >
                        {icon}
                    </div>

                </div>

                <h4
                    className="mt-3 mb-2"
                    style={{
                        fontSize:17,
                        fontWeight:700
                    }}
                >
                    {value}
                </h4>

                <div
                    className="d-flex align-items-center"
                    style={{
                        fontSize:13
                    }}
                >

                    {hasGrowth ? (
                        <>
                            {
                                positive
                                    ? <TrendingUp
                                        size={15}
                                        color="#28C76F"
                                      />
                                    : <TrendingDown
                                        size={15}
                                        color="#EA5455"
                                      />
                            }

                            <span
                                style={{
                                    marginLeft:5,
                                    color:positive
                                        ? "#28C76F"
                                        : "#EA5455",
                                    fontWeight:600
                                }}
                            >
                                {growth}%
                            </span>

                            {/*
                              La etiqueta va más pequeña que el porcentaje: lo
                              que importa leer es la variación, no contra qué.
                              El rango exacto del período comparado queda en el
                              tooltip, para no cargar la tarjeta con fechas.
                            */}
                            <span
                                className="ms-2"
                                title={growthTitle || undefined}
                                style={{
                                    color:"#6E6B7B",
                                    fontSize:11,
                                    cursor:growthTitle ? "help" : "default"
                                }}
                            >
                                {growthLabel}
                            </span>
                        </>
                    ) : (
                        <span style={{ color:"#B9B9C3" }}>
                            {pendingNote || "Sin período anterior para comparar"}
                        </span>
                    )}

                </div>

            </CardBody>
        </Card>
    );

};

export default DashboardStatCard;